import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  AuditoriaProcessoListResult,
  FetchAuditoriaProcessoArgs,
  FiltrosDisponiveisAuditoria,
} from '../../types/auditoriaProcesso';
import { auditoriaProcessoService } from './services';

const reject = (error: unknown): string =>
  error instanceof Error ? error.message : 'Erro desconhecido';

export const fetchAuditoriaProcesso = createAsyncThunk<
  AuditoriaProcessoListResult,
  FetchAuditoriaProcessoArgs,
  { rejectValue: string }
>('secretariaArbitralAuditoria/fetch', async (args, { rejectWithValue }) => {
  try {
    return await auditoriaProcessoService.listar(args);
  } catch (error) {
    return rejectWithValue(reject(error));
  }
});

export const fetchFiltrosAuditoriaProcesso = createAsyncThunk<
  FiltrosDisponiveisAuditoria,
  string,
  { rejectValue: string }
>('secretariaArbitralAuditoria/fetchFiltros', async (processoArbitralId, { rejectWithValue }) => {
  try {
    return await auditoriaProcessoService.listarFiltros(processoArbitralId);
  } catch (error) {
    return rejectWithValue(reject(error));
  }
});
